module.exports = __webpack_public_path__ + "static/favicon-0bc8ff00ba116db1b2c0fd54251002a4.ico";